import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

const _expand$ = new Subject<string[]>();

export interface ExpandedTable {
    [index: string]: boolean;
}

/**
 * Cada módulo monta su propio layout, así que el menú se destruye y se vuelve a crear al cambiar de
 * módulo. Esta tabla (singleton, en memoria) es la que conserva los grupos abiertos entre montajes.
 */
@Injectable()
export class SideNavService {
    expandedTable: ExpandedTable = {};

    get expand$() {
        return _expand$;
    }

    isExpanded(hash: string): boolean {
        if (this.expandedTable[hash]) {
            return true;
        }
        return false;
    }

    setExpanded(hash: string, expanded: boolean) {
        this.expandedTable[hash] = expanded;
    }

    /** Ir a Home olvida los grupos abiertos: el menú vuelve a montarse con todo colapsado. */
    saveCache(hierarchyExtension: string[], link: string) {
        if (!link.match(/^\/dashboard/)) {
            return;
        }
        this.expandedTable = {};
        hierarchyExtension.forEach(id => (this.expandedTable[id] = true));
    }
}
